import * as React from "react";
import { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import pageIds from "pageIds";
import { CommonProjectRunbookTriggersOverview, CommonProjectRunbookTriggersTopics } from "../../CommonComponents/CommonProjectRunbookTriggersView";

export const ProjectRunbooksTriggersRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.project().runbook.triggers,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonProjectRunbookTriggersOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonProjectRunbookTriggersTopics />;
    },
};
